import React from "react";
import StatisticsContainer from "../components/stats/StatisticsContainer";

const Statistics = () => {
  return <StatisticsContainer />;
};

export default Statistics;
